/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable  @typescript-eslint/no-unused-vars */
/* eslint-disable  @typescript-eslint/consistent-indexed-object-style */
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
import { forkJoin, Observable, Subject, BehaviorSubject, firstValueFrom } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ApiService {
	constructor(private httpClient: HttpClient, private router: Router) { }

	public API_URL = environment.API_URL;
	public MFA_API_URL = environment.MFA_API_URL;

	private doctorDataSubject = new BehaviorSubject<any>(null);
	doctorData$ = this.doctorDataSubject.asObservable();
	setDoctorData(data: any): void {
		this.doctorDataSubject.next(data);
	}

	private mailSelectSubject = new BehaviorSubject<any>(null);
	mailSelectEvent$ = this.mailSelectSubject.asObservable();
	setMailSelect(data: any): void {
		this.mailSelectSubject.next(data);
	}

	private userDataSubject = new BehaviorSubject<any>(null);
	userData$ = this.userDataSubject.asObservable();
	setUserData(data: any): void {
		this.userDataSubject.next(data);
	}

	private followupListRefresh = new Subject<any>();
	sendFollowUpFilesRefreshEvent() {
		this.followupListRefresh.next(true);
	}
	getFollowUpFilesRefreshEvent(): Observable<any> {
		return this.followupListRefresh.asObservable();
	}

	private mailCountChange = new Subject<any>();
	sendCountChangeEvent() {
		this.mailCountChange.next(null);
	}
	getCountChangeEvent(): Observable<any> {
		return this.mailCountChange.asObservable();
	}

	private callDisconnected = new Subject<any>();
	sendCallDisconnectedEvent(case_id: any) {
		this.callDisconnected.next(case_id);
	}
	getCallDisconnectedEvent(): Observable<any> {
		return this.callDisconnected.asObservable();
	}

	private attachmentSubject = new BehaviorSubject<any>(null);
	attachmentData$ = this.attachmentSubject.asObservable();
	setAttachmentData(data: any): void {
		this.attachmentSubject.next(data);
	}

	private viewportSubject = new BehaviorSubject<any>(null);
	viewportData$ = this.viewportSubject.asObservable();
	setViewportData(data: any): void {
		this.viewportSubject.next(data);
	}

	/* private viewportSubject1 = new BehaviorSubject<any>(null);
	viewportData1$ = this.viewportSubject1.asObservable();
	setViewportData1(data: any): void {
		this.viewportSubject1.next(data);
	} */

	private attChangeSubject = new BehaviorSubject<any>(null);
	attChangedData$ = this.attChangeSubject.asObservable();
	setAttChangedData(data: any): void {
		this.attChangeSubject.next(data);
	}

	private callJoinSubject = new Subject<any>();
	callJoinData$ = this.callJoinSubject.asObservable();
	sendCallJoinStatus(data: boolean) {
		this.callJoinSubject.next(data);
	}

	getDefaultDateRange(returnString: boolean) {
		const today = new Date();
		const yesterday = new Date();
		yesterday.setDate(yesterday.getDate() - 1);
		return {
			start_date: returnString ? this.getDateStringFromDate(yesterday) : yesterday,
			end_date: returnString ? this.getDateStringFromDate(today) : today
		}
	}

	getDefaultDateRange3Months(returnString: boolean) {
		const today = new Date();
		const fromDate = new Date();
		fromDate.setDate(fromDate.getDate() - 90);
		return {
			start_date: returnString ? this.getDateStringFromDate(fromDate) : fromDate,
			end_date: returnString ? this.getDateStringFromDate(today) : today
		}
	}


	getDateTimeStringFromDate(dateObj: any) {
		if (dateObj == "" || dateObj == null || dateObj == undefined) {
			return "";
		}
		var month = dateObj.getMonth() + 1;
		var day = dateObj.getDate();
		var year = dateObj.getFullYear();
		var dayStr = day < 10 ? '0' + day : day;
		var monthStr = month < 10 ? '0' + month : month;
		var hour = dateObj.getHours() + "";
		var minutes = dateObj.getMinutes() + "";
		var seconds = dateObj.getSeconds() + "";
		hour = this.checkZero(hour);
		minutes = this.checkZero(minutes);
		seconds = this.checkZero(seconds);
		return year + "-" + monthStr + "-" + dayStr + " " + hour + ":" + minutes + ":" + seconds;
	}

	checkZero(data: any) {
		if (data != undefined && data.toString().length == 1) {
			data = "0" + data;
		}
		return data;
	}

	getDateStringFromDate(date: any): string {
		if (!date) {
			return "";
		}
		if (typeof date === 'string' || typeof date === 'number') {
			date = new Date(date);
		}
		if (!(date instanceof Date) || isNaN(date.getTime())) {
			return "";
		}
		const month = date.getMonth() + 1;
		const day = date.getDate();
		const year = date.getFullYear();
		const dayStr = day < 10 ? '0' + day : day.toString();
		const monthStr = month < 10 ? '0' + month : month.toString();
		const fromStr = `${year}-${monthStr}-${dayStr}`;
		return fromStr;
	}

	getDateStringFromDateDMY(date: any): string {
		if (!date) {
			return "";
		}
		if (typeof date === 'string' || typeof date === 'number') {
			date = new Date(date);
		}
		if (!(date instanceof Date) || isNaN(date.getTime())) {
			return "";
		}
		const month = date.getMonth() + 1;
		const day = date.getDate();
		const year = date.getFullYear();
		const dayStr = day < 10 ? '0' + day : day.toString();
		const monthStr = month < 10 ? '0' + month : month.toString();
		const fromStr = `${dayStr}-${monthStr}-${year}`;
		return fromStr;
	}

	getDateFromDateString(date: any) {
		if (date == "" || date == null || date == undefined) {
			return null;
		}
		try {
			date = date.split("T")[0];
			let dateArr = date.split("-");
			dateArr = dateArr.reverse();
			date = new Date(dateArr.join("/"));
		} catch (error) {
			date = null;
		}
		return date;
	}

	getDateFromDateStringYMD(date: any) {
		if (date == "" || date == null || date == undefined) {
			return null;
		}
		try {
			date = date.split("T")[0];
			let dateArr = date.split("-");
			date = new Date(dateArr.join("/"));
		} catch (error) {
			date = null;
		}
		return date;
	}

	public getHomeURL() {
		return "/" + this.getNavbar() + "/dashboard";
	}

	public getNavbar() {
		if (localStorage.getItem("usertype") == "Company") {
			return "comp";
		} else {
			return "app";
		}
	}

	navigateToLogin(storeState: boolean) {
		localStorage.clear();
		this.setUserData(null);
		if (storeState) {
			this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.routerState.snapshot.url } });
		} else {
			this.router.navigate(['/login']);
		}
	}


	public currencyList() {
		return this.httpClient.get("./assets/files/currencies.json");
	}

	public deleteUserProfile(user: any) {
		return this.httpClient.post(this.API_URL + 'api/app_delete_request', user);
	}

	public loginAPI(user: any) {
		return this.httpClient.post(this.API_URL + "api/signin", user);
	}

	public logout() {
		return this.httpClient.get(this.API_URL + "api/signOut");
	}

	public isMFAActivated(data: any) {
		return this.httpClient.post(this.MFA_API_URL + "is_mfa_activated", data);
	}

	public activateMFA(data: any) {
		return this.httpClient.post(this.MFA_API_URL + "activate_mfa", data);
	}

	public disableMFA(data: any) {
		return this.httpClient.post(this.MFA_API_URL + "disable_mfa", data);
	}

	public verifyMFA(data: any) {
		return this.httpClient.post(this.MFA_API_URL + "verify_mfa", data);
	}

	public resetPassword(data: any) {
		return this.httpClient.post(this.API_URL + "api/changePassword", data);
	}

	public reset2fa(data: any) {
		return this.httpClient.post(this.API_URL + "api/reset2fa", data);
	}

	public generate_qr(data: any) {
		return this.httpClient.post(this.API_URL + "api/generate_qr", data, { responseType: "blob" });
	}

	public verifyGoogleAuthOTP(params: any) {
		const httpParams: HttpParamsOptions = { fromObject: params } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.API_URL + "api/verify_otp", options);
	}

	public countryCodes() {
		return this.httpClient.get("./assets/files/countryCodes.json");
	}

	public country() {
		return this.httpClient.get(this.API_URL + "api/country");
	}

	public countryList() {
		return this.httpClient.get(this.API_URL + "api/nationality");
	}

	public stateList(countryId: any) {
		const httpParams: HttpParamsOptions = { fromObject: { country: countryId } } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.API_URL + "api/states", options);
	}

	public cityList(stateId: any) {
		const httpParams: HttpParamsOptions = { fromObject: { state: stateId } } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.API_URL + "api/cities", options);
	}

	public allVisitTypeApi() {
		return this.httpClient.get(this.API_URL + "api/allVisitTypeApi");
	}

	public deleteAirport(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		if (data === 'select') {
			return this.httpClient.delete(this.API_URL + "api/airport");
		} else {
			return this.httpClient.delete(this.API_URL + "api/airport", { params: new HttpParams(httpParams) });
		}
	}

	public deleteFollowUpBills(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "api/follow-up-bills", { params: new HttpParams(httpParams) });
	}

	public getAirport(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/airport", { params: new HttpParams(httpParams) });
	}

	public createUpdateAirport(data: any) {
		const url = this.API_URL + "api/airport";
		if (data.id) {
			return this.httpClient.put(url, data);
		} else {
			return this.httpClient.post(url, data);
		}
	}

	public getFollowupList(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/follow-up", { params: new HttpParams(httpParams) });
	}

	public getFollowupDetails(followUpId: any) {
		const httpParams: HttpParamsOptions = { fromObject: { id: followUpId } } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/follow-details", { params: new HttpParams(httpParams) });
	}

	public getApptAndFollowUpDetails(apptId: any, followUpId: any): Observable<any[]> {
		const httpParams1: HttpParamsOptions = { fromObject: { id: encodeURIComponent(apptId) } } as HttpParamsOptions;
		const httpParams2: HttpParamsOptions = { fromObject: { id: followUpId } } as HttpParamsOptions;
		let response1 = this.httpClient.get(this.API_URL + "api/update-case-details", { params: new HttpParams(httpParams1) });
		let response2 = this.httpClient.get(this.API_URL + "api/follow-details", { params: new HttpParams(httpParams2) });
		return forkJoin([response1, response2]);
	}

	public getModeOfTransportation() {
		return this.httpClient.get(this.API_URL + "api/modeOfTransportation");
	}

	public getAllFollowUpStatus() {
		return this.httpClient.get(this.API_URL + "api/allFollowUpStatus");
	}
	public getCaseCategory() {
		return this.httpClient.get(this.API_URL + "api/all-case-category");
	}

	createUpdateFollowup(data: any) {
		let url = `${this.API_URL}api/follow-up`;
		if (data.id) {
			return this.httpClient.put(url, data);
		} else {
			return this.httpClient.post(url, data);
		}
	}

	sendFollowUpBills(data: any[]): Observable<any> {
		const url = this.API_URL + "api/follow-up-bills";
		return this.httpClient.post(url, data);
	}

	getFollowUpFiles(data) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/follow-up-files", { params: new HttpParams(httpParams) });
	}

	saveFollowUpFiles(data) {
		return this.httpClient.post(this.API_URL + "api/follow-up-files", data);
	}

	public deleteFollowUpFiles(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "api/follow-up-files", { params: new HttpParams(httpParams) });
	}

	///////////////////////////
	getFollowUpAdditionalFiles(data) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/additional-follow-up-files", { params: new HttpParams(httpParams) });
	}

	saveFollowUpAdditionalFiles(data) {
		return this.httpClient.post(this.API_URL + "api/additional-follow-up-files", data);
	}

	public deleteFollowUpAdditionalFiles(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "api/additional-follow-up-files", { params: new HttpParams(httpParams) });
	}
	///////////////////////////

	public deleteFollowUp(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "api/follow-up", { params: new HttpParams(httpParams) });
	}

	public deleteCase(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "api/case", { params: new HttpParams(httpParams) });
	}

	public getCase(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/case", { params: new HttpParams(httpParams) });
	}

	public getMultipleCases(idList: any) {
		return this.httpClient.post(this.API_URL + "api/multiple_case_details", { ids: idList });
	}

	public getUpdateCaseDetails(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/update-case-details", { params: new HttpParams(httpParams) });
	}

	public updateCaseDetails(data: any) {
		return this.httpClient.put(this.API_URL + "api/update-case-details", data);
	}

	public fetchHcData(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/fetch-and-save-hc-data", { params: new HttpParams(httpParams) });
	}

	public createUpdateCase(data: any) {
		const url = this.API_URL + "api/case";
		if (data.id) {
			return this.httpClient.post(url, data);
		} else {
			return this.httpClient.post(url, data);
		}
	}

	public getAllBillList() {
		return this.httpClient.get(this.API_URL + "api/all-bill-types");
	}

	public deleteDoctor(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "api/doctor", { params: new HttpParams(httpParams) });
	}

	public getDoctor(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/doctor", { params: new HttpParams(httpParams) });
	}

	public getDoctorList(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/hospital-wise-doctor", { params: new HttpParams(httpParams) });
	}

	public getFolloupBills(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/follow-up-bills", { params: new HttpParams(httpParams) });
	}

	public getFolloupBillsByCase(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/follow-up-bills-by-case", { params: new HttpParams(httpParams) });
	}

	public getFitnesStatus() {
		return this.httpClient.get(this.API_URL + "api/fitness-status");
	}

	public createUpdateDoctor(data: FormData) {
		const url = this.API_URL + "api/doctor";
		if (data.has("id")) {
			return this.httpClient.put(url, data);
		} else {
			return this.httpClient.post(url, data);
		}
	}

	public deleteRoomType(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "api/roomType", { params: new HttpParams(httpParams) });
	}

	public getRoomType(data: any) {
		if (data == 'list') {
			return this.httpClient.get(this.API_URL + "api/roomType");
		}
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/roomType", { params: new HttpParams(httpParams) });
	}

	public createUpdateRoomtype(data: any) {
		const url = this.API_URL + "api/roomType";
		if (data.id) {
			return this.httpClient.put(url, data);
		} else {
			return this.httpClient.post(url, data);
		}
	}

	public deleteLabTest(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "api/labTest", { params: new HttpParams(httpParams) });
	}

	public getLabTest(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/labTest", { params: new HttpParams(httpParams) });
	}

	public createUpdateLabTest(data: any) {
		const url = this.API_URL + "api/labTest";
		if (data.id) {
			return this.httpClient.put(url, data);
		} else {
			return this.httpClient.post(url, data);
		}
	}

	public deleteHospital(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "api/hospital", { params: new HttpParams(httpParams) });
	}

	public getHospital(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/hospital", { params: new HttpParams(httpParams) });
	}

	public getHospitalsByCity(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/hospital_by_city", { params: new HttpParams(httpParams) });
	}

	public createUpdateHospital(data: any) {
		const url = this.API_URL + "api/hospital";
		if (data.id) {
			return this.httpClient.put(url, data);
		} else {
			return this.httpClient.post(url, data);
		}
	}

	public deleteMedicine(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "api/medicine", { params: new HttpParams(httpParams) });
	}

	public getMedicine(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/medicine", { params: new HttpParams(httpParams) });
	}

	public createUpdateMedicine(data: any) {
		const url = this.API_URL + "api/medicine";
		if (data.id) {
			return this.httpClient.put(url, data);
		} else {
			return this.httpClient.post(url, data);
		}
	}

	public deleteSurgery(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "api/surgery", { params: new HttpParams(httpParams) });
	}

	public getSurgery(data: any) {
		if (data == 'list') {
			return this.httpClient.get(this.API_URL + "api/surgery");
		}
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/surgery", { params: new HttpParams(httpParams) });
	}

	public createUpdateSurgery(data: any) {
		const url = this.API_URL + "api/surgery";
		if (data.id) {
			return this.httpClient.put(url, data);
		} else {
			return this.httpClient.post(url, data);
		}
	}

	public deleteRank(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "api/rank", { params: new HttpParams(httpParams) });
	}

	public getRank(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/rank", { params: new HttpParams(httpParams) });
	}

	public createUpdateRank(data: any) {
		const url = this.API_URL + "api/rank";
		if (data.id) {
			return this.httpClient.put(url, data);
		} else {
			return this.httpClient.post(url, data);
		}
	}

	public deleteCompany(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "api/company", { params: new HttpParams(httpParams) });
	}

	public getCompany(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/company", { params: new HttpParams(httpParams) });
	}

	public createUpdateCompany(data: FormData) {
		const url = this.API_URL + "api/company";
		if (data.has("id")) {
			return this.httpClient.put(url, data);
		} else {
			return this.httpClient.post(url, data);
		}
	}

	public uploadReport(data: FormData) {
		const url = this.API_URL + "api/upload-report";
		return this.httpClient.post(url, data);
	}

	public reportFiles(data) {

		const url = this.API_URL + "api/report-files";
		return this.httpClient.post(url, data);
	}

	public deleteVessel(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "api/vessel", { params: new HttpParams(httpParams) });
	}

	public getVessel(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/vessel", { params: new HttpParams(httpParams) });
	}

	public createUpdateVessel(data: any) {
		const url = this.API_URL + "api/vessel";
		if (data.id) {
			return this.httpClient.put(url, data);
		} else {
			return this.httpClient.post(url, data);
		}
	}

	public getallCategory() {
		return this.httpClient.get(this.API_URL + "api/allCategory");
	}

	public getallDepartments() {
		return this.httpClient.get(this.API_URL + "api/allDepartments");
	}

	public getStatus() {
		return this.httpClient.get(this.API_URL + "api/caseStatus");
	}

	public uploadFile(data: any) {
		return this.httpClient.post(this.API_URL + "api/upload-files", data);
	}

	public fileDelete(data: any) {
		return this.httpClient.post(this.API_URL + "api/delete-files", data);
	}

	public billFileDelete(data: any) {
		return this.httpClient.post(this.API_URL + "api/delete-bill-file", data);
	}

	public invoiceListByCase(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/invoice", { params: new HttpParams(httpParams) });
	}

	public invoiceListByCaseUSD(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/usd-invoice", { params: new HttpParams(httpParams) });
	}

	public createUpdateInvoice(data: any) {
		if (data.id) {
			return this.httpClient.put(this.API_URL + "api/invoice", data);
		} else {
			return this.httpClient.post(this.API_URL + "api/invoice", data);
		}
	}

	public deleteInvoice(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "api/invoice", { params: new HttpParams(httpParams) });
	}

	public deleteInvoiceItem(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "api/delete-invoice-item", { params: new HttpParams(httpParams) });
	}

	public getInvoiceDetails(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/invoice-details", { params: new HttpParams(httpParams) });
	}

	public createUpdateUSDInvoice(data: any) {
		if (data.id) {
			return this.httpClient.put(this.API_URL + "api/usd-invoice", data);
		} else {
			return this.httpClient.post(this.API_URL + "api/usd-invoice", data);
		}
	}

	public deleteUSDInvoice(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "api/usd-invoice", { params: new HttpParams(httpParams) });
	}

	public invoicePDFINR(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/invoice-pdf", { params: new HttpParams(httpParams), observe: 'response', responseType: 'arraybuffer' });
	}

	/* public invoicePDFINR1(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/invoice-pdf1", { params: new HttpParams(httpParams), observe: 'response', responseType: 'arraybuffer' });
	} */

	public invoicePDFUSD(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/usd-invoice-pdf", { params: new HttpParams(httpParams), observe: 'response', responseType: 'arraybuffer' });
	}

	public getClosureReportDetails(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/closure-report", { params: new HttpParams(httpParams) });
	}

	public saveClosureReportDetails(data: any) {
		return this.httpClient.post(this.API_URL + "api/closure-report", data);
	}

	public verifyPassword(data: any) {
		return this.httpClient.post(this.API_URL + "api/closure-report-password-check", data);
	}

	public closureReportPDF(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/closure-report-pdf", { params: new HttpParams(httpParams), observe: 'response', responseType: 'arraybuffer' });
	}

	public getAllCaseCategories() {
		return this.httpClient.get(this.API_URL + "api/all-case-category");
	}

	public followupListDashboard(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/follow-up-list-dashboard", { params: new HttpParams(httpParams) });
	}

	public getCaseReminders(id: any) {
		const httpParams: HttpParamsOptions = { fromObject: { id: id } } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/case-reminders", { params: new HttpParams(httpParams) });
	}

	public getFeedbackQuestions(apptId: any): Observable<any[]> {
		const httpParams1: HttpParamsOptions = { fromObject: { id: apptId } } as HttpParamsOptions;
		let response1 = this.httpClient.get(this.API_URL + "api/case-feedback", { params: new HttpParams(httpParams1) });
		let response2 = this.httpClient.get(this.API_URL + "api/all-feedback-quetions");
		return forkJoin([response1, response2]);
	}

	public submitFeedback(data: any) {
		return this.httpClient.post(this.API_URL + "api/case-feedback", data);
	}

	public unlinkFromHC(id: any) {
		const httpParams: HttpParamsOptions = { fromObject: { id: id } } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/unlink_from_hc", { params: new HttpParams(httpParams) });
	}

	public getOTP(data: any) {
		return this.httpClient.post(this.API_URL + "api/send-otp", data);
	}

	public verifyOTP(data: any) {
		return this.httpClient.post(this.API_URL + "api/verify-otp", data);
	}

	public getUserTypes(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/user-types", { params: new HttpParams(httpParams) });
	}

	public getDoctors(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/doctor_list", { params: new HttpParams(httpParams) });
	}

	public getUserTypesAndDoctors(): Observable<any[]> {
		const response1 = this.httpClient.get(this.API_URL + "api/user-types");
		const response2 = this.httpClient.get(this.API_URL + "api/doctor");
		return forkJoin([response1, response2]);
	}

	public getHandover(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/handover", { params: new HttpParams(httpParams) });
	}

	public doneHandover(data: any) {
		return this.httpClient.put(this.API_URL + "api/handover", data);
	}

	public createUpdateCity(data: any) {
		return this.httpClient.post(this.API_URL + "api/cities", data);
	}

	public getCasesExcel(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/case-excel", { params: new HttpParams(httpParams), observe: 'response', responseType: 'arraybuffer' });
	}

	public getCompanyCasesExcel(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/case-excel-company", { params: new HttpParams(httpParams), observe: 'response', responseType: 'arraybuffer' });
	}

	public getPrescriptionPdf(data: any) {
		return this.httpClient.post(this.API_URL + "api/prescription-pdf", data, { observe: 'response', responseType: 'arraybuffer' });
	}

	public getPrescription(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/prescription", { params: new HttpParams(httpParams) });
	}

	public casePrescriptionList(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/prescription", { params: new HttpParams(httpParams) });
	}

	public addCaseMeds(data: any) {
		return this.httpClient.post(this.API_URL + "api/prescription", data);
	}

	public getLabTestsPdf(data: any) {
		return this.httpClient.post(this.API_URL + "api/lab-prescription-pdf", data, { observe: 'response', responseType: 'arraybuffer' });
	}

	public getLabTests(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/prescription", { params: new HttpParams(httpParams) });
	}

	public caseLabTestsList(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/prescription", { params: new HttpParams(httpParams) });
	}

	public addCaseLabTests(data: any) {
		return this.httpClient.post(this.API_URL + "api/prescription", data);
	}

	public deleteUser(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "api/users", { params: new HttpParams(httpParams) });
	}

	public createUpdateUser(data: any) {
		const url = this.API_URL + "api/users";
		if (data.id) {
			return this.httpClient.put(url, data);
		} else {
			return this.httpClient.post(url, data);
		}
	}

	public getUserDetails(data: any) {
		const httpParams2: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/users", { params: new HttpParams(httpParams2) });
	}

	public getLoggedInUser() {
		return this.httpClient.get(this.API_URL + "api/user_details");
	}

	public updateUser(data: any) {
		return this.httpClient.put(this.API_URL + "api/user_details", data);
	}

	public saveDeviceToken(token: any, user_id: any, device_id: string) {
		const data = { "device_token": token, "user_id": user_id, "device_id": device_id };
		return this.httpClient.post(this.API_URL + "api/DeviceMasterApi/", data);
	}

	public getReferralFile(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/referral", { params: new HttpParams(httpParams), observe: 'response', responseType: 'arraybuffer' });
	}

	public createTeleconFollowUps(data: any) {
		return this.httpClient.post(this.API_URL + "api/create_all_tele_consults", data);
	}

	public monthWiseCountChart(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/monthwise_case_counts", { params: new HttpParams(httpParams) });
	}

	public icdCodeWiseCount(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/icdcodewise_case_counts", { params: new HttpParams(httpParams) });
	}

	public billedUnbilledCounts(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/bill_unbilled_case_counts", { params: new HttpParams(httpParams) });
	}

	public hospitalizedOtherCounts(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/hs_case_counts", { params: new HttpParams(httpParams) });
	}

	public caseListByFlag(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/case_list_by_flag", { params: new HttpParams(httpParams) });
	}

	public followUpReportPDF(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/follow_up_report_pdf", { params: new HttpParams(httpParams), observe: 'response', responseType: 'arraybuffer' });
	}

	public saveFollowUpReport(data: any) {
		return this.httpClient.put(this.API_URL + "api/follow_up_report", data);
	}

	public getSnapshotCompanyData1(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/snapshot_of_cases", { params: new HttpParams(httpParams) });
	}

	public getSnapshotCompanyData2(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/month_view_of_cases", { params: new HttpParams(httpParams) });
	}

	public getCallCounts() {
		return this.httpClient.get(this.API_URL + "api/call_counts");
	}

	public getMailCounts() {
		return this.httpClient.get(this.API_URL + "api/MailCount/");
	}

	public getMails(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/MailboxApi/", { params: new HttpParams(httpParams) });
	}

	public getMultipleMail(mailIds: any[]): Observable<any[]> {
		let responses: Observable<any>[] = [];
		for (let i = 0; i < mailIds.length; i++) {
			const httpParams: HttpParamsOptions = { fromObject: { id: mailIds[i] } } as HttpParamsOptions;
			let response = this.httpClient.get(this.API_URL + "api/MailboxApi/", { params: new HttpParams(httpParams) });
			responses.push(response);
		}
		return forkJoin(responses);
	}

	public saveMail(data: any) {
		return this.httpClient.post(this.API_URL + "api/MailboxApi/", data);
	}

	public linkMail(data: any) {
		return this.httpClient.post(this.API_URL + "api/MailLinkToEvent/", data);
	}

	public unlinkMail(data: any) {
		return this.httpClient.post(this.API_URL + "api/MailUnlinkToEvent/", data);
	}

	public mailStatusChange(mailId: any) {
		return this.httpClient.post(this.API_URL + "api/MailStatusChange/", { mail_id: mailId });
	}

	public getMailContent(url: any) {
		return this.httpClient.get(url, { responseType: "text" });
	}

	public getReimbursementPdf(id: any) {
		const httpParams: HttpParamsOptions = { fromObject: { id: id } } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/reimbursement_pdf", { params: new HttpParams(httpParams), observe: 'response', responseType: 'arraybuffer' });
	}

	public fileUploadMultiple(fileNames: string[], destination: string): Observable<any[]> {
		let responses: Observable<any>[] = [];
		for (let i = 0; i < fileNames.length; i++) {
			const payload = {
				file_name: fileNames[i],
				destination: destination
			};
			let response = this.httpClient.post(this.API_URL + "api/GeneratePresignedUrlApi/", payload);
			responses.push(response);
		}
		return forkJoin(responses);
	}

	public changeSpamStatus(data: any) {
		return this.httpClient.post(this.API_URL + "api/MailSpam/", data);
	}

	public deleteMail(data: any) {
		return this.httpClient.post(this.API_URL + "api/MailboxApiDelete/", data);
	}

	public fetchImageForCid(cid: string) {
		const cleanCid = cid.startsWith('cid:') ? cid.slice(4) : cid;
		return firstValueFrom(
			/* this.httpClient.get(`${this.API_URL}api/mail-image/${encodeURIComponent(cleanCid)}`) */
			this.httpClient.get(window.location.origin + "/assets/img/no_image.png", { observe: 'response', responseType: 'arraybuffer' })
		);
	}

	public copyMailFilesToBilling(data: any) {
		return this.httpClient.post(this.API_URL + "api/copy-files", data);
	}

	public updateMailAttachment(data: any) {
		return this.httpClient.post(this.API_URL + "api/UpdateMailAttachment", data);
	}

	public getCaseSummary(id: any) {
		return this.httpClient.post(this.API_URL + "api/case_summary", { id: id });
	}

	public getCaseCountsForDashboard() {
		return this.httpClient.get(this.API_URL + "api/case-counts-for-dashboard");
	}

	public getCalls(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/call_list", { params: new HttpParams(httpParams) });
	}

	public caseListFromSnapshot(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/snapshot_of_case_list", { params: new HttpParams(httpParams) });
	}

	public getQuestions(data: any) {
		return this.httpClient.post(this.API_URL + "api/get_icd_codes_and_questions_from_text", data);
	}

	public getAllCaseQuestions(id: any) {
		const httpParams: HttpParamsOptions = { fromObject: { id: id } } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/get_icd_codes_and_questions_from_text", { params: new HttpParams(httpParams) });
	}

	public getAgoraToken(user_id: number, channel_name: string) {
		const httpParams: HttpParamsOptions = { fromObject: { channel_name: channel_name, user_id: user_id.toString() } } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/agora_token", { params: new HttpParams(httpParams) });
	}

	public getAgoraTokens(user_id: number, channel_name: string, username: string): Observable<any[]> {
		const httpParams1: HttpParamsOptions = { fromObject: { channel_name: channel_name, user_id: user_id.toString() } } as HttpParamsOptions;
		const httpParams2: HttpParamsOptions = { fromObject: { username: username } } as HttpParamsOptions;
		let response1 = this.httpClient.get(this.API_URL + "api/agora_token", { params: new HttpParams(httpParams1) });
		let response2 = this.httpClient.get(this.API_URL + "api/agora_token", { params: new HttpParams(httpParams2) });
		return forkJoin([response1, response2]);
	}

	public saveFollowupQuestions(data: any) {
		return this.httpClient.put(this.API_URL + "api/get_icd_codes_and_questions_from_text", data);
	}

	public saveReportDetils(data: any) {
		return this.httpClient.put(this.API_URL + "api/follow_up_report_details", data);
	}

	public registerChatUser(data: any) {
		return this.httpClient.post(this.API_URL + "api/register_chat_user", data);
	}

	public registerChatUsers(usernames: string[]): Observable<any[]> {
		let responses: Observable<any>[] = [];
		for (let i = 0; i < usernames.length; i++) {
			let response = this.httpClient.post(this.API_URL + "api/register_chat_user", { username: usernames[i] });
			responses.push(response);
		}
		return forkJoin(responses);
	}

	public createChatRoom(data: any) {
		return this.httpClient.post(this.API_URL + "api/create_chat_room", data);
	}

	public getCaseFilesFromCandidate(case_id: any) {
		const httpParams: HttpParamsOptions = { fromObject: { caseid: case_id } } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/case_files", { params: new HttpParams(httpParams) });
	}

	public linkCandidateFiles(data: any) {
		return this.httpClient.put(this.API_URL + "api/link_case_files", data);
	}

	public pushNotification(data: any) {
		return this.httpClient.post(this.API_URL + "api/push_notification", data);
	}

	public getUsersInChannel(channel_name: any) {
		const httpParams: HttpParamsOptions = { fromObject: { channel_name: channel_name } } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/call_users", { params: new HttpParams(httpParams) });
	}

	public startRecording(cname: any) {
		return this.httpClient.post(this.API_URL + "api/start_recording", { cname: cname });
	}

	public stopRecording(data: any) {
		return this.httpClient.post(this.API_URL + "api/stop_recording", data);
	}

	public markAllMailsAsReplied(id: any) {
		return this.httpClient.put(this.API_URL + "api/mark-all-mail-replied", { id: id });
	}

	public getCallRecordings(id: any) {
		const httpParams: HttpParamsOptions = { fromObject: { id: id } } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/recordings", { params: new HttpParams(httpParams) });
	}

	public getAmountFromImage(file_path: any) {
		const httpParams: HttpParamsOptions = { fromObject: { file_path: file_path } } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/get_amount", { params: new HttpParams(httpParams) });
	}

	public getAdminNotes(case_id: any) {
		const httpParams: HttpParamsOptions = { fromObject: { id: case_id } } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/case_administrative_notes", { params: new HttpParams(httpParams) });
	}

	public createUpdateAdminNotes(data: any) {
		const url = this.API_URL + "api/case_administrative_notes";
		if (data.id) {
			return this.httpClient.put(url, data);
		} else {
			delete data.id;
			return this.httpClient.post(url, data);
		}
	}

	public deletAdminNotes(id: any) {
		const httpParams: HttpParamsOptions = { fromObject: { id: id } } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "api/case_administrative_notes", { params: new HttpParams(httpParams) });
	}

	public getCaseBillsPdfs(case_id: any) {
		const httpParams: HttpParamsOptions = { fromObject: { caseid: case_id } } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/bills-pdf", { params: new HttpParams(httpParams) });
	}

	public getFollowupListAndSingle(followUpId: any, caseId: any): Observable<any[]> {
		const httpParams1: HttpParamsOptions = { fromObject: { id: caseId } } as HttpParamsOptions;
		const httpParams2: HttpParamsOptions = { fromObject: { id: followUpId } } as HttpParamsOptions;
		let response1 = this.httpClient.get(this.API_URL + "api/follow-up", { params: new HttpParams(httpParams1) });
		let response2 = this.httpClient.get(this.API_URL + "api/follow-details", { params: new HttpParams(httpParams2) });
		return forkJoin([response1, response2]);
	}

	public getAllICDCodes() {
		return this.httpClient.get(this.API_URL + "api/icd-codes");
	}

	public createUpdateICDCode(data: any) {
		const url = this.API_URL + "api/icd-codes";
		if (data.id) {
			return this.httpClient.put(url, data);
		} else {
			delete data.id;
			return this.httpClient.post(url, data);
		}
	}

	public getTreatmentCosts(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/treatment-costs", { params: new HttpParams(httpParams) });
	}

	public deleteTreatmentCosts(id: any) {
		const httpParams: HttpParamsOptions = { fromObject: { id: id } } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "api/treatment-costs", { params: new HttpParams(httpParams) });
	}

	public createUpdateTreatmentCost(data: any) {
		const url = this.API_URL + "api/treatment-costs";
		if (data.id) {
			return this.httpClient.put(url, data);
		} else {
			delete data.id;
			return this.httpClient.post(url, data);
		}
	}

	public getHumanAnatomyAllCoordinates() {
		return this.httpClient.get("./assets/vendor/human-anatomy/anatomy-ml-fl-ft-bk/all-points.json");
	}

	public update_coordinates(params: any) {
		return this.httpClient.post(this.API_URL + "api/update_coordinates", params);
	}

	public getFCT(followUpId: any) {
		const httpParams: HttpParamsOptions = { fromObject: { id: followUpId } } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/fct", { params: new HttpParams(httpParams) })
	}

	public saveFCT(params: any) {
		return this.httpClient.post(this.API_URL + "api/fct", params);
	}

	public getFCTReport(followUpId: number | string): Observable<Blob> {
		const params = new HttpParams().set('id', followUpId);
		return this.httpClient.get(`${this.API_URL}api/fct-pdf`, {
			params,
			responseType: 'blob'
		});
	}

	public qrcodeNotification(params: any) {
		return this.httpClient.post(this.API_URL + "api/qrcode-notification", params);
	}

	public getRegisteredCandidates(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/app_registered_candidate", { params: new HttpParams(httpParams) });
	}

	public deleteMailTemplate(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.delete(this.API_URL + "api/mail-templates", { params: new HttpParams(httpParams) });
	}

	public getMailTemplate(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.API_URL + "api/mail-templates", { params: new HttpParams(httpParams) });
	}

	public createUpdateMailTemplate(data: any) {
		const url = this.API_URL + "api/mail-templates";
		if (data.id) {
			return this.httpClient.put(url, data);
		} else {
			return this.httpClient.post(url, data);
		}
	}
}

export interface HttpParamsOptions {
	fromString?: string;
	fromObject?: {
		[param: string]: string | string[];
	};
	encoder?: HttpParameterCodec;
}

interface HttpParameterCodec {
	encodeKey(key: string): string
	encodeValue(value: string): string
	decodeKey(key: string): string
	decodeValue(value: string): string
}